$(document).ready(function () {
    $('#customer-responsibles-table').DataTable({
        dom: 'fBlrtip',
        language: {
            url: '/data_tables_translation.json'
        }
    });
});
